import * as actionTypes from "./actionTypes";
import * as actions from './index';


export const updateSortObjectsSuccess = (data) => {
    return {
        type: actionTypes.SORT_UPDATE_SORTOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateSortObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateSortObjectsSuccess(obj));
    }
}